import { IonCard, IonCardHeader, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonLoading, IonPage, IonRow, IonTitle, IonToolbar } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";
import { emailVerifyQuery } from "../../apollo-client/queries";
import { Redirect, useHistory, useLocation } from "react-router";
import { useTenant } from "../../hooks/multiTenancy";
import queryString from 'query-string';
import { informationCircle, warning } from "ionicons/icons";
import "./auth.css";
import { useEffect } from "react";
import { EmailVerifyData } from "../../apollo-client/types";

const EmailVerify: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const tenant = useTenant();
  const { search } = useLocation();

  const { otlToken, webOrigin } = queryString.parse(search);
  const isWebOrigin = webOrigin ? ((typeof webOrigin === "string" ? webOrigin : webOrigin[0]) === "true") : false;

  const { loading: emailVerifyLoading, called: emailVerifyCalled, data: emailVerifyData } = useQuery<EmailVerifyData>(emailVerifyQuery, {
    variables: { oneTimeLogin: otlToken },
  });

  useEffect(() => {
    if (!!emailVerifyData && !emailVerifyData.emailVerify.alreadyVerified && isWebOrigin) {
      setTimeout(() => {
        history.push("/app/home");
      }, 2000);
    }
  }, [emailVerifyData, isWebOrigin]);

  const getCardMessage = (emailVerifyData: EmailVerifyData | undefined, isWebOrigin: boolean): string => {
    if (!emailVerifyData) {
      return "auth.verify_email_error";
    } else if (emailVerifyData.emailVerify.alreadyVerified) {
      return "auth.verify_email_already_verified";
    } else if (isWebOrigin) {
      return  "auth.verify_email_success";
    } else {
      return "auth.verify_email_success_app";
    }
  }

  if (!otlToken || typeof otlToken !== "string") {
    return <Redirect to="/" />;
  }

  return (
    <IonPage className="auth">
      <IonLoading isOpen={emailVerifyLoading} message={t("loading")} />
      <IonHeader>
        <IonToolbar color="secondary">
          <IonTitle>{t("auth.verify_email")}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="background-image" style={{ backgroundImage: `url('${tenant.baseURL}/background.png')` }} />
        <div className="background-shadow" />
        {emailVerifyCalled && !emailVerifyLoading && (
          <div className="content top-bar">
            <IonGrid>
              <IonRow className="">
                <IonCol size="12">
                  <IonCard className="result-card">
                    <IonGrid>
                      <IonRow>
                        <IonCol size="2">
                          <IonIcon
                            className="icon"
                            icon={!emailVerifyData ? warning : informationCircle}
                            color={!emailVerifyData ? "warning" : "success"}
                          />
                        </IonCol>
                        <IonCol size="10">
                          <IonCardHeader>
                            <IonCardTitle>{t(getCardMessage(emailVerifyData, isWebOrigin))}</IonCardTitle>
                          </IonCardHeader>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCard>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        )}
      </IonContent>
    </IonPage>
  );
};

export default EmailVerify;
